import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import firebase from "../../../firebase";
import "firebase/firestore";

const db = firebase.firestore();

export default function FormDialog(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    db.collection("empresas").doc(props.empresa.id).delete();
    setOpen(false);
  };

  return (
    <div>
      <div onClick={handleClickOpen}>{props.children}</div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Eliminar establecimiento
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Seguro que desea eliminar el establecimiento seleccionado?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Borrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
